export default "/assets/heart-white-outline.svg";